import styled, { css } from "styled-components";
import Button from "@streeteasy/design-system/deprecated/Button";
import colors from "@streeteasy/design-system/deprecated/colors";

import { largeScreen } from "src/shared/constants/screenSizes";

export const SubmitButtonContainer = styled.div`
  background: white;
  border-top: 1px solid ${colors.rabbitGrey};
  bottom: 0;
  padding: 15px;
  position: fixed;
  width: 100%;
  
  ${({ $hasCancelOnMobile }) =>
    $hasCancelOnMobile &&
    css`
      display: flex;
      flex-direction: column;
    `}

  @media (min-width: ${largeScreen}px) {
    border-top: 1px solid ${colors.foxGrey};
    display: flex;
    flex-direction: row;
    padding: 20px 60px 20px;
    width: 480px;
    position: unset;
  }
`;

export const CancelButton = styled(Button)`
  ${({ $hasCancelOnMobile }) =>
    $hasCancelOnMobile
      ? css`
          margin-bottom: 16px;
          width: 100%;
          @media (min-width: ${largeScreen}px) {
            display: block;
            margin: auto;
          }
        `
      : css`
          display: none;
          @media (min-width: ${largeScreen}px) {
            display: block;
          }
        `}
    
  @media (min-width: ${largeScreen}px) {
    margin-right: 10px;
  }
`;

export const SubmitButton = styled(Button)`
  &:disabled {
    background-color: ${colors.primaryTouched};
    border-color: ${colors.primaryTouched};
    cursor: not-allowed;

    &:hover,
    &:active {
      background-color: ${colors.primaryTouched};
      border-color: ${colors.primaryTouched};
    }

    &:after {
      animation: loadingButton 1.5s ease-in-out forwards;
      background-color: rgba(0, 0, 0, 0.2);
      content: "";
      display: block;
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
    }

    @keyframes loadingButton {
      0% {
        right: 100%;
      }
      100% {
        right: 8px;
      }
    }
  }
`;
